import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const showroomListRequest = createAction(types.SHOWROOM_LIST_REQUEST);
export const showroomListSuccess = createAction(types.SHOWROOM_LIST_SUCCESS);
export const showroomListFailure = createAction(types.SHOWROOM_LIST_FAILURE);

export const recentDealListRequest = createAction(
  types.RECENT_DEAL_LIST_REQUEST,
);
export const recentDealListSuccess = createAction(
  types.RECENT_DEAL_LIST_SUCCESS,
);
export const recentDealListFailure = createAction(
  types.RECENT_DEAL_LIST_FAILURE,
);

export const allDealsRequest = createAction(types.ALL_DEALS_REQUEST);
export const allDealsSuccess = createAction(types.ALL_DEALS_SUCCESS);
export const allDealsFailure = createAction(types.ALL_DEALS_FAILURE);

export const dealRequest = createAction(types.DEAL_REQUEST);
export const dealSuccess = createAction(types.DEAL_SUCCESS);
export const dealFailure = createAction(types.DEAL_FAILURE);

export const dealUpdateRequest = createAction(types.DEAL_UPDATE_REQUEST);
export const dealUpdateSuccess = createAction(types.DEAL_UPDATE_SUCCESS);
export const dealUpdateFailure = createAction(types.DEAL_UPDATE_FAILURE);

export const financeResponseUpdateFailure = createAction(
  types.FINANCE_RESPONSE_UPDATE_FAILURE,
);

export const setDealTradeIns = createAction(types.SET_DEAL_TRADEINS);

export const dealTradeInsUpdateSuccess = createAction(
  types.DEAL_TRADEINS_UPDATE_SUCCESS,
);
export const dealTradeInsUpdateFailure = createAction(
  types.DEAL_TRADEINS_UPDATE_FAILURE,
);
export const updateTradeInsForDMS = createAction(types.UPDATE_TRADEINS_FOR_DMS);

export const dealCreateRequest = createAction(types.DEAL_CREATE_REQUEST);
export const dealCreateSuccess = createAction(types.DEAL_CREATE_SUCCESS);
export const dealCreateFailure = createAction(types.DEAL_CREATE_FAILURE);

export const onlineDealCreateRequest = createAction(
  types.ONLINE_DEAL_CREATE_REQUEST,
);
export const onlineDealCreateSuccess = createAction(
  types.ONLINE_DEAL_CREATE_SUCCESS,
);
export const onlineDealCreateFailure = createAction(
  types.ONLINE_DEAL_CREATE_FAILURE,
);

export const dealCRMPushRequest = createAction(types.DEAL_CRM_PUSH_REQUEST);
export const dealCRMPushSuccess = createAction(types.DEAL_CRM_PUSH_SUCCESS);
export const dealCRMPushFailure = createAction(types.DEAL_CRM_PUSH_FAILURE);

export const dealDMSPushRequest = createAction(types.DEAL_DMS_PUSH_REQUEST);
export const dealDMSPushSuccess = createAction(types.DEAL_DMS_PUSH_SUCCESS);
export const dealDMSPushFailure = createAction(types.DEAL_DMS_PUSH_FAILURE);

export const dealDMSPushOfferRequest = createAction(
  types.DEAL_DMS_PUSH_OFFER_REQUEST,
);
export const dealDMSPushOfferSuccess = createAction(
  types.DEAL_DMS_PUSH_OFFER_SUCCESS,
);
export const dealDMSPushOfferFailure = createAction(
  types.DEAL_DMS_PUSH_OFFER_FAILURE,
);

export const setPrimaryCarRequest = createAction(types.SET_PRIMARY_CAR_REQUEST);
export const setPrimaryCarSuccess = createAction(types.SET_PRIMARY_CAR_SUCCESS);
export const setPrimaryCarFailure = createAction(types.SET_PRIMARY_CAR_FAILURE);

export const carRequest = createAction(types.CAR_REQUEST);
export const carSuccess = createAction(types.CAR_SUCCESS);
export const carFailure = createAction(types.CAR_FAILURE);

export const userRequest = createAction(types.USER_REQUEST);
export const userSuccess = createAction(types.USER_SUCCESS);
export const userFailure = createAction(types.USER_FAILURE);

export const dealerRequest = createAction(types.DEALER_REQUEST);
export const dealerSuccess = createAction(types.DEALER_SUCCESS);
export const dealerFailure = createAction(types.DEALER_FAILURE);

export const pencilRequest = createAction(types.PENCIL_REQUEST);
export const pencilSuccess = createAction(types.PENCIL_SUCCESS);
export const pencilFailure = createAction(types.PENCIL_FAILURE);

export const pencilCreateRequest = createAction(types.PENCIL_CREATE_REQUEST);
export const pencilCreateSuccess = createAction(types.PENCIL_CREATE_SUCCESS);
export const pencilCreateFailure = createAction(types.PENCIL_CREATE_FAILURE);

export const pencilUpdateRequest = createAction(types.PENCIL_UPDATE_REQUEST);
export const pencilUpdateSuccess = createAction(types.PENCIL_UPDATE_SUCCESS);
export const pencilUpdateFailure = createAction(types.PENCIL_UPDATE_FAILURE);

export const pencilCRMPushRequest = createAction(types.PENCIL_CRM_PUSH_REQUEST);
export const pencilCRMPushSuccess = createAction(types.PENCIL_CRM_PUSH_SUCCESS);
export const pencilCRMPushFailure = createAction(types.PENCIL_CRM_PUSH_FAILURE);

export const paymentsRequest = createAction(types.PAYMENTS_REQUEST);
export const paymentsSuccess = createAction(types.PAYMENTS_SUCCESS);
export const paymentsFailure = createAction(types.PAYMENTS_FAILURE);
export const paymentsReset = createAction(types.PAYMENTS_RESET);

export const setPencil = createAction(types.SET_PENCIL);
export const initPencil = createAction(types.INIT_PENCIL);
export const updateRequestStatus = createAction(types.UPDATE_REQUEST_STATUS);

export const selectedCarsRequest = createAction(types.SELECTED_CARS_REQUEST);
export const selectedCarsSuccess = createAction(types.SELECTED_CARS_SUCCESS);
export const selectedCarsFailure = createAction(types.SELECTED_CARS_FAILURE);
export const selectedCarsUpdateCar = createAction(
  types.SELECTED_CARS_UPDATE_CAR,
);

export const printStickerRequest = createAction(types.PRINT_STICKER_REQUEST);
export const printStickerSuccess = createAction(types.PRINT_STICKER_SUCCESS);
export const printStickerFailure = createAction(types.PRINT_STICKER_FAILURE);

export const sendStickerRequest = createAction(types.SEND_STICKER_REQUEST);
export const sendStickerSuccess = createAction(types.SEND_STICKER_SUCCESS);
export const sendStickerFailure = createAction(types.SEND_STICKER_FAILURE);

export const pushingToCRM = createAction(types.PUSHING_TO_CRM);
export const pushingToDMS = createAction(types.PUSHING_TO_DMS);

export const setPencilModalText = createAction(types.SET_PENCIL_MODAL_TEXT);

export const forwardDealToFNI = createAction(types.FORWARD_TO_FNI_REQUEST);
export const forwardDealToFNISuccess = createAction(
  types.FORWARD_TO_FNI_SUCCESS,
);

export const forwardDealToFNIFailure = createAction(
  types.FORWARD_TO_FNI_FAILURE,
);

export const loadDealData = createAction(types.LOAD_DEAL_DATA_REQUEST);
export default {
  showroomListRequest,
  showroomListSuccess,
  showroomListFailure,
  recentDealListRequest,
  recentDealListSuccess,
  recentDealListFailure,
  allDealsRequest,
  allDealsSuccess,
  allDealsFailure,
  dealRequest,
  dealSuccess,
  dealFailure,
  carRequest,
  carSuccess,
  carFailure,
  userRequest,
  userSuccess,
  userFailure,
  dealerRequest,
  dealerSuccess,
  dealerFailure,
  setPencil,
  initPencil,
  pencilRequest,
  pencilSuccess,
  pencilFailure,
  pencilCreateRequest,
  pencilCreateSuccess,
  pencilCreateFailure,
  pencilUpdateRequest,
  pencilUpdateSuccess,
  pencilUpdateFailure,
  paymentsRequest,
  paymentsSuccess,
  paymentsFailure,
  paymentsReset,
  dealUpdateRequest,
  dealUpdateSuccess,
  dealUpdateFailure,
  setDealTradeIns,
  dealTradeInsUpdateFailure,
  updateRequestStatus,
  pencilCRMPushRequest,
  pencilCRMPushSuccess,
  pencilCRMPushFailure,
  dealCreateRequest,
  dealCreateSuccess,
  dealCreateFailure,
  dealCRMPushRequest,
  dealCRMPushSuccess,
  dealCRMPushFailure,
  dealDMSPushRequest,
  dealDMSPushSuccess,
  dealDMSPushFailure,
  dealDMSPushOfferRequest,
  dealDMSPushOfferSuccess,
  dealDMSPushOfferFailure,
  setPrimaryCarRequest,
  setPrimaryCarSuccess,
  setPrimaryCarFailure,
  printStickerRequest,
  printStickerSuccess,
  printStickerFailure,
  sendStickerRequest,
  sendStickerSuccess,
  sendStickerFailure,
  pushingToCRM,
  pushingToDMS,
  setPencilModalText,
  forwardDealToFNI,
  forwardDealToFNIFailure,
  forwardDealToFNISuccess,
  loadDealData,
  updateTradeInsForDMS,
};
